<template>
  <transition name="transition-fade" appear mode="out-in">
    <slot> </slot>
  </transition>
</template>

<script>
export default {
  /*
   * Main transition used throughout the whole application.
   */
  name: 'TheTransition',
};
</script>

<style lang="scss" scoped>
.transition-fade-enter-active,
.transition-fade-leave-active {
  transition: opacity 0.15s;
}
.transition-fade-enter,
.transition-fade-leave-to {
  opacity: 0;
}
</style>
